module.exports = __webpack_public_path__ + "static/media/sweepForeground.e07c99a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Sweep/sweepForeground.svg
// module id = 934
// module chunks = 0